module.exports = __webpack_public_path__ + "static/media/event_error.38d71807.png";